"use strict";
/**
 * Accesso dei client MCP (Claude, Cursor) a nome di un membro del team (DEC-015 decisione 3,
 * PRD-007 US-1, ADR-005): EasyHelp è l'authorization server OAuth 2.1 della risorsa `/mcp`.
 * Qui i contratti condivisi fra api e web: durate, codici d'errore, schermata di consenso.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MCP_AUTHORIZATION_DECISIONS = exports.MCP_REDIRECT_KINDS = exports.MCP_AUTHORIZATION_ERROR_MESSAGES = exports.MCP_AUTHORIZATION_PAGE_ERRORS = exports.MCP_ERROR_CODES = exports.MCP_SCOPE = exports.MCP_AUTHORIZATION_REQUEST_TTL_MINUTES = exports.MCP_CONNECTION_MAX_AGE_DAYS = exports.MCP_ACCESS_TOKEN_TTL_SECONDS = exports.VIA_MCP_LABEL = exports.ACTION_ORIGINS = void 0;
exports.isMcpAuthorizationPageError = isMcpAuthorizationPageError;
/**
 * Origine dell'azione (DEC-015 decisione 6, glossario): la console oppure un client MCP. È solo
 * interna: non esce mai verso consumer, webhook o email.
 */
exports.ACTION_ORIGINS = ['console', 'mcp'];
/** La dicitura accanto al nome di chi ha agito nella cronologia della console (DEC-015 decisione 6). */
exports.VIA_MCP_LABEL = 'via MCP';
/** Durata dell'access token MCP: al massimo 15 minuti (DEC-015). */
exports.MCP_ACCESS_TOKEN_TTL_SECONDS = 15 * 60;
/**
 * Durata massima di una connessione MCP: 30 giorni dal consenso (DEC-015, nota del 2026-11-02),
 * distinta dalla sessione della console, che resta di 7 (DEC-007). È assoluta: i refresh token
 * ruotano ma non la allungano. Dopo, il client ripassa dal login Google e dal consenso.
 */
exports.MCP_CONNECTION_MAX_AGE_DAYS = 30;
/** Tempo per dare o negare il consenso dopo che il client ha avviato l'autorizzazione. */
exports.MCP_AUTHORIZATION_REQUEST_TTL_MINUTES = 10;
/** Unico scope dell'MCP: i permessi effettivi sono quelli del ruolo del membro (DEC-015 decisione 4). */
exports.MCP_SCOPE = 'mcp';
/** Codici di errore dell'accesso MCP (ADR-004). */
exports.MCP_ERROR_CODES = {
    /** `client_id` sconosciuto all'avvio dell'autorizzazione: il client va ricollegato (400). */
    clientNotFound: 'mcp.client_not_found',
    /** Redirect URI fuori dall'allowlist o non registrato dal client (400). */
    redirectUriNotAllowed: 'mcp.redirect_uri_not_allowed',
    /** Richiesta di autorizzazione scaduta, già decisa, inesistente o aperta da un altro browser (404). */
    authorizationNotFound: 'mcp.authorization_not_found',
    /** Access token assente, non valido, scaduto o della connessione revocata (401 su `/mcp`). */
    tokenInvalid: 'mcp.token_invalid',
    /** Troppe chiamate agli strumenti dalla stessa connessione MCP nel minuto (#154). */
    rateLimited: 'mcp.rate_limited',
    /** Il risultato di uno strumento supera la dimensione massima: va chiesta una pagina più piccola (#154). */
    outputTooLarge: 'mcp.output_too_large',
    /** Connessione da revocare già chiusa (revocata o scaduta), inesistente o di un altro membro (404). */
    connectionNotFound: 'mcp.connection_not_found',
    /** Allegato in un formato che il modello non legge (per esempio un PDF): si apre nella console (#155). */
    attachmentTypeUnsupported: 'mcp.attachment_type_unsupported',
    /** Allegato oltre il limite per il modello (immagine o testo): si apre nella console, mai troncato (#155). */
    attachmentTooLarge: 'mcp.attachment_too_large',
};
/**
 * Errori che la pagina `/autorizzazione-mcp/errore?codice=` sa spiegare: l'avvio dell'autorizzazione
 * non può tornare al client (redirect non fidato) e manda il browser alla console.
 */
exports.MCP_AUTHORIZATION_PAGE_ERRORS = [
    exports.MCP_ERROR_CODES.clientNotFound,
    exports.MCP_ERROR_CODES.redirectUriNotAllowed,
    exports.MCP_ERROR_CODES.authorizationNotFound,
];
exports.MCP_AUTHORIZATION_ERROR_MESSAGES = {
    'mcp.client_not_found': 'EasyHelp non riconosce il client che ha chiesto il collegamento. Rimuovi EasyHelp dal client (Claude o Cursor) e aggiungilo di nuovo.',
    'mcp.redirect_uri_not_allowed': 'Il client ha chiesto di tornare a un indirizzo che EasyHelp non ammette: il collegamento è consentito solo da claude.ai, Claude Code e Cursor.',
    'mcp.authorization_not_found': 'La richiesta di collegamento è scaduta, è già stata usata o è stata avviata da un altro browser. Torna al client e avvia di nuovo il collegamento da questo computer.',
};
/** Vero se `value` è un errore che la pagina dell'autorizzazione MCP sa spiegare. */
function isMcpAuthorizationPageError(value) {
    return typeof value === 'string' && exports.MCP_AUTHORIZATION_PAGE_ERRORS.includes(value);
}
/**
 * Dove torna il browser dopo il consenso, per la schermata: `web` un sito (claude.ai), `app`
 * un'applicazione con schema proprio (Cursor), `locale` un programma su questo computer (loopback:
 * Claude Code, Cursor). Un indirizzo locale merita un avviso: qualunque processo può ascoltarlo.
 */
exports.MCP_REDIRECT_KINDS = ['web', 'app', 'locale'];
/** Decisione sulla richiesta: `POST /mcp/oauth/authorizations/:id/decision`. */
exports.MCP_AUTHORIZATION_DECISIONS = ['consenti', 'nega'];
//# sourceMappingURL=mcp-oauth.js.map